import { format, parseISO } from "date-fns"

export function dateToString(date: Date): string
export function dateToString(date: Date | null | undefined): string | null
export function dateToString(date: Date | null | undefined): string | null {
  if (!date) return null
  return format(date, "yyyy-MM-dd'T'HH:mm:ss.SSSxxx")
}

export function stringToDate<T extends string | null | undefined>(
  a: T,
): T extends string ? Date | null : T
export function stringToDate(
  dateString: string | null | undefined,
): Date | null | undefined {
  if (dateString === undefined) return undefined
  if (dateString === null) return null

  try {
    return parseISO(dateString)
  } catch (error) {
    console.error("Failed to parse date string:", error)
    return null
  }
}
